export const API_ORGANISATIONS_MEMBERSHIPS_INDEX = 'API_ORGANISATIONS_MEMBERSHIPS_INDEX'

export const fetchMemberships = (organisationId: number) => ({
  type: API_ORGANISATIONS_MEMBERSHIPS_INDEX,
  organisationId,
})
